<form [formGroup]="reproductionForm" (ngSubmit)="onSubmitted()">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <h3
            class="card-header"
            *ngIf="reprModalType === addReproduction; else editTitle"
          >
            Reproducție nouă
          </h3>
          <ng-template #editTitle>
            <h3 class="card-header">
              {{
                isAutoritateJudeteana || isContabil
                  ? "Vizualizează reproducție"
                  : "Editează reproducție"
              }}
            </h3>
          </ng-template>

          <div
            *ngIf="loadingDataSpinner"
            class="spinner-border text-info table-spinner avatar-xxl"
            role="status"
          ></div>

          <div *ngIf="!loadingDataSpinner" class="card-body">
            <div class="row">
              <div class="col-sm-12 col-xl-5 mb-3 mr-4">
                <label>Tip reproducție</label>

                <ng-select
                  (change)="schimbareTipReproductie($event)"
                  formControlName="tip_reproductie"
                  [clearable]="false"
                  [ngClass]="{ disabled: reprModalType !== addReproduction }"
                >
                  <ng-option [value]="1">Însămânțare artificială</ng-option>
                  <ng-option [value]="2">Montă naturală autorizată</ng-option>
                  <ng-option [value]="3">Embriotransferuri</ng-option>
                </ng-select>
              </div>

              <div class="col-sm-12 col-xl-6 mb-3">
                <label>Exploatația</label>

                <div>
                  {{ nume_exploatatie }} - {{ cod_exploatatie }}

                  <a
                    *ngIf="cod_exploatatie"
                    [routerLink]="
                      '/dashboard/exploatatie/' +
                      cod_exploatatie +
                      '/reproductie'
                    "
                    target="_blank"
                    class="ml-2 fs-3"
                    ><i class="mdi mdi-open-in-new mr-1"></i
                  ></a>
                </div>
              </div>
            </div>

            <app-reproductie-insamantare-artificiala
              *ngIf="reproductionForm.value.tip_reproductie === 1"
              [monta]="monta"
              [form]="reproductionForm"
              [field_errors]="field_errors"
            >
            </app-reproductie-insamantare-artificiala>

            <app-reproductie-monta-naturala
              *ngIf="reproductionForm.value.tip_reproductie === 2"
              [monta]="monta"
              [form]="reproductionForm"
              [field_errors]="field_errors"
            >
            </app-reproductie-monta-naturala>

            <app-reproductie-embriotransfer
              *ngIf="reproductionForm.value.tip_reproductie === 3"
              [monta]="monta"
              [form]="reproductionForm"
              [field_errors]="field_errors"
            >
            </app-reproductie-embriotransfer>

            <div class="row mt-2">
              <div class="col-12 mb-3">
                <label>Status</label>

                <ng-select
                  formControlName="status"
                  class="w12"
                  [clearable]="false"
                  [ngClass]="{
                    disabled: disabledFields['status'],
                    'is-invalid': field_errors['status']
                  }"
                >
                  <ng-option [value]="0">În așteptare</ng-option>
                  <ng-option [value]="1">Verificare</ng-option>
                  <ng-option [value]="2">Operare</ng-option>
                  <ng-option [value]="3">Validat</ng-option>
                  <ng-option [value]="4">Refuzat</ng-option>
                </ng-select>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-12">
                <button
                  class="btn btn-secondary mr-3"
                  type="button"
                  (click)="closeFormMethod()"
                >
                  Închide
                </button>

                <button
                  *ngIf="
                    reprModalType == editReproduction &&
                    (isAdmin ||
                      isOperator ||
                      (isFermier && f.status.value === 0))
                  "
                  class="btn btn-danger"
                  type="button"
                  (click)="openConfirmActionModal()"
                >
                  Șterge
                </button>

                <button
                  *ngIf="
                    isAdmin || isOperator || (isFermier && f.status.value === 0)
                  "
                  class="btn btn-success float-right"
                  type="submit"
                >
                  <span *ngIf="reprModalType === addReproduction; else editBtn">
                    Salvează
                  </span>

                  <ng-template #editBtn>
                    <span>Actualizează</span>
                  </ng-template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<app-confirm-action-modal
  [open]="openConfirmModal"
  [type]="'delete-repr'"
  (confirm)="closeConfirmModal($event)"
></app-confirm-action-modal>
